export default __webpack_public_path__ + "static/media/aboutimg.ed6dc32d.png";